// extracted by mini-css-extract-plugin
export default {"container":"HospitalIcon_container__TqC61","layout-width":"HospitalIcon_layout-width__VNaW2","hospital-bar":"HospitalIcon_hospital-bar__7miP2","item":"HospitalIcon_item__Cn9ow"};